module.exports = __webpack_public_path__ + "static/media/full-logo.ab2dfdec.png";